import './less/cookiesBar.less';

const CookiesBar = () => {
	
	let handler = document.getElementById('JS__cookieHandler');
	let cookiesBar = document.getElementById('cookiesBar');

	if(handler && cookiesBar) {
		const closeCookiesBar = event => {
			event.preventDefault();
			cookiesBar.classList.remove('showed');
			localStorage.setItem('miCookieInfo', 1);
		};

		handler.addEventListener('click', closeCookiesBar);

		if (localStorage.getItem("miCookieInfo") == 1) {
			cookiesBar.classList.remove('showed');
		}
	}
};

const cookiesBar = CookiesBar();
export default cookiesBar;


// WEBPACK FOOTER //
// ../components/core/cookiesBar/cookiesBar.js